import { FaCloudDownloadAlt, FaSyncAlt } from "react-icons/fa";
import "./index.css";
import BookingDetails from "../TicketDetails";

const BookingDetailCard = ({ booking, handleDownloadE_Tickets, ticketLoader, updateBookingApi, updateBookingLoader }) => {
    if (!booking) return <p>No booking details available.</p>;

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleString();
    };


    const convertedResponseShow = (status) => {
        if (status === "waitingfordistributor") {
            return "Waiting for distributor"
        }
        return status
    }


    const buttonShowStatus = booking?.booking_ticket?.[0]?.isUpdateStatus

    return (
        <div className="booking-details">
            <div className="bookin-details-title">
                <h3 className="booking-title">Booking Details</h3>
            </div>

            <div className="booking-details-info">
                <p><strong>Booking ID:</strong> {`TRP${booking?.id}`}</p>
                {booking?.booking_email && <p><strong>Email:</strong> {booking?.booking_email}</p>}
                {booking?.client_id && <p><strong>Client ID:</strong> {booking?.client_id}</p>}
                {booking?.created_by && <p><strong>Created By:</strong> {booking?.created_by}</p>}
                {booking?.created && <p><strong>Created Date:</strong> {formatDate(booking?.created)}</p>}
                {booking?.booking_code && <p><strong>Booking Code:</strong> {booking?.booking_code}</p>}
                {booking?.distributor_id && <p><strong>Distributor Id:</strong> {booking?.distributor_id}</p>}
                {booking?.guestdata_status &&
                    <p><strong>Guest Data Status:</strong> {convertedResponseShow(booking?.guestdata_status)}</p>
                }
                {
                    booking?.supplier_booking_id &&
                    <p><strong>Supplier Booking ID:</strong> {booking?.supplier_booking_id}</p>
                }
                {
                    booking?.payment_reference &&
                    <p><strong>Payment Reference:</strong> {booking?.payment_reference}</p>
                }
            </div>
            {
                buttonShowStatus !== 0 &&
                <div className="booking_info_btn" >
                    {
                        buttonShowStatus === 1 &&
                        <button
                            className="download-btn"
                            onClick={handleDownloadE_Tickets}
                            disabled={ticketLoader || updateBookingLoader}
                        >
                            {ticketLoader ? "Downloading..." : "Download Ticket"} <FaCloudDownloadAlt size={20} />

                        </button>
                    }
                    {
                        buttonShowStatus === 2 &&
                        <button
                            className="update-btn"
                            onClick={updateBookingApi}
                            disabled={ticketLoader || updateBookingLoader}
                        >
                            {updateBookingLoader ? "Updating..." : "Update Booking"} <FaSyncAlt size={20} />
                        </button>
                    }
                </div>
            }

            {/* Booking Tickets */}
            <div className="booking-tickets">
                <h4>Tickets</h4>
                {booking?.booking_ticket?.length > 0 ? (
                    booking?.booking_ticket.map((ticket, index) => (
                        <div key={ticket.id} className="ticket-card">
                            <p><strong>Event:</strong> {ticket.event_name}</p>
                            <p><strong>Ticket Type:</strong> {ticket.ticket_title}</p>
                            <p><strong>Category:</strong> {ticket.category_name} ({ticket.category_type})</p>
                            <p><strong>Price:</strong> {ticket.net_rate_inr} INR</p>
                            <p><strong>Event Date:</strong> {formatDate(ticket.event_startdate)}</p>
                        </div>
                    ))
                ) : (
                    <p>No tickets available</p>
                )}
            </div>
        </div>
    );
};

export default BookingDetailCard;
